export type PublicEnvironment = {
  apiBaseUrl: string;
  supabaseUrl?: string;
  supabaseAnonKey?: string;
  release: string;
  isE2eAuthBypassAllowed: boolean;
};

function isLoopbackHostname(hostname: string): boolean {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
}

export function allowsE2eAuthBypass(flag: string | undefined, hostname: string): boolean {
  return flag === "true" && isLoopbackHostname(hostname);
}

export function readPublicEnvironment(): PublicEnvironment {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();
  const hostname = typeof window === "undefined" ? "" : window.location.hostname;
  const isE2eAuthBypassAllowed = allowsE2eAuthBypass(
    import.meta.env.VITE_E2E_AUTH_BYPASS,
    hostname,
  );

  return {
    apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/$/, ""),
    ...(supabaseUrl ? { supabaseUrl } : {}),
    ...(supabaseAnonKey ? { supabaseAnonKey } : {}),
    release: import.meta.env.VITE_RELEASE ?? "development",
    isE2eAuthBypassAllowed,
  };
}

export const publicEnvironment = readPublicEnvironment();
